import { env } from "~/env";
import { mfoTheme as boomzaimMfoTheme } from "./boomzaim";
import { MfoTheme } from "./MfoTheme";

export const mfoTheme: MfoTheme = (() => {
  if (env.VITE_MFO_THEME === "boomzaim") {
    return boomzaimMfoTheme;
  }

  throw new Error(`Unknown theme: ${env.VITE_MFO_THEME}`);
})();
